export const serviceAreasData = [
  {
    id: 1,
    slug: 'london',
    name: 'London',
    region: 'Greater London',
    population: '9.5 million',
    description: 'As the UK\'s capital and largest city, London presents incredible opportunities for businesses to thrive online. Our web design services help London businesses stand out in this competitive market with professional, conversion-focused websites.',
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&h=400&fit=crop',
    clients: [
      'Thames Construction Ltd',
      'London Elite Cleaning',
      'Capital City Plumbers',
      'Metropolitan Electricians'
    ],
    services: [
      'Professional Website Design',
      'E-commerce Development',
      'Local SEO Optimization',
      'Mobile-First Design',
      'Brand Identity Design',
      'Digital Marketing'
    ],
    keyPoints: [
      'Highly competitive market requiring standout design',
      'Focus on local SEO for borough-specific searches',
      'Mobile-first approach for busy London commuters',
      'Trust signals essential for London customers'
    ]
  },
  {
    id: 2,
    slug: 'birmingham',
    name: 'Birmingham',
    region: 'West Midlands',
    population: '1.1 million',
    description: 'Birmingham\'s thriving business community needs websites that reflect the city\'s dynamic growth. We help Birmingham businesses establish a strong online presence with modern, professional web design.',
    image: 'https://images.unsplash.com/photo-1599833975787-5c143f373c30?w=600&h=400&fit=crop',
    clients: [
      'Midlands Building Services',
      'Birmingham Garden Masters',
      'City Centre Cleaners',
      'Brum Electrical Solutions'
    ],
    services: [
      'Custom Website Development',
      'Responsive Web Design',
      'Content Management Systems',
      'SEO Services',
      'Website Maintenance',
      'Social Media Integration'
    ],
    keyPoints: [
      'Growing tech sector with modern design expectations',
      'Strong manufacturing heritage requiring professional presentation',
      'Diverse business community needing flexible solutions',
      'Competitive pricing important for local market'
    ]
  },
  {
    id: 3,
    slug: 'manchester',
    name: 'Manchester',
    region: 'Greater Manchester',
    population: '2.7 million',
    description: 'Manchester\'s vibrant business scene demands cutting-edge web design. We create websites that capture the innovative spirit of this northern powerhouse while delivering real business results.',
    image: 'https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=600&h=400&fit=crop',
    clients: [
      'Northern Construction Co',
      'Manchester Maintenance',
      'Red Rose Cleaning',
      'Greater Manchester Electricians'
    ],
    services: [
      'Modern Web Design',
      'E-commerce Solutions',
      'Digital Strategy',
      'Brand Development',
      'Performance Optimization',
      'Analytics Setup'
    ],
    keyPoints: [
      'Tech-savvy population expecting modern design',
      'Strong digital marketing ecosystem',
      'Growing startup scene requiring scalable solutions',
      'Northern business culture valuing authenticity'
    ]
  },
  {
    id: 4,
    slug: 'leeds',
    name: 'Leeds',
    region: 'West Yorkshire',
    population: '800,000',
    description: 'Leeds is a major business hub in Yorkshire, and we help local companies compete with professional web design that showcases their expertise and attracts customers throughout the region.',
    image: 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=600&h=400&fit=crop',
    clients: [
      'Yorkshire Building Solutions',
      'Leeds Professional Cleaning',
      'White Rose Plumbing',
      'Yorkshire Electrical Services'
    ],
    services: [
      'Business Website Design',
      'Local SEO Services',
      'Content Creation',
      'Website Hosting',
      'Ongoing Support',
      'Performance Monitoring'
    ],
    keyPoints: [
      'Strong business community requiring professional image',
      'Yorkshire values of quality and reliability',
      'Growing financial sector with high standards',
      'Regional pride important in messaging'
    ]
  },
  {
    id: 5,
    slug: 'glasgow',
    name: 'Glasgow',
    region: 'Scotland',
    population: '630,000',
    description: 'Scotland\'s largest city deserves websites that reflect its proud heritage and modern ambitions. We create web designs that help Glasgow businesses succeed in the digital age.',
    image: 'https://images.unsplash.com/photo-1555664424-778a1e5e1b48?w=600&h=400&fit=crop',
    clients: [
      'Scottish Building Contractors',
      'Glasgow City Cleaning',
      'Highland Plumbing Services',
      'Clyde Electrical Solutions'
    ],
    services: [
      'Scottish Business Websites',
      'Responsive Design',
      'Local Market SEO',
      'Brand Identity',
      'Digital Marketing',
      'Website Analytics'
    ],
    keyPoints: [
      'Strong local identity requiring authentic messaging',
      'Competitive business environment',
      'Tech sector growth demanding modern solutions',
      'Scottish business culture valuing relationships'
    ]
  },
  {
    id: 6,
    slug: 'liverpool',
    name: 'Liverpool',
    region: 'Merseyside',
    population: '500,000',
    description: 'Liverpool\'s entrepreneurial spirit needs websites that match its energy and ambition. We help Merseyside businesses create compelling online presences that drive growth.',
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&h=400&fit=crop',
    clients: [
      'Mersey Construction Ltd',
      'Liverpool Marine Services',
      'Scouse Cleaning Solutions',
      'Merseyside Electrical'
    ],
    services: [
      'Creative Web Design',
      'Maritime Industry Websites',
      'Local Business SEO',
      'Mobile Optimization',
      'Content Strategy',
      'Social Media Integration'
    ],
    keyPoints: [
      'Creative culture appreciating innovative design',
      'Strong maritime and logistics sectors',
      'Community-focused business approach',
      'Growing tech and digital sectors'
    ]
  },
  {
    id: 7,
    slug: 'bristol',
    name: 'Bristol',
    region: 'South West England',
    population: '470,000',
    description: 'Bristol\'s creative and tech scene demands websites that are both beautiful and functional. We help Bristol businesses stand out with award-winning web design.',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=600&h=400&fit=crop',
    clients: [
      'West Country Builders',
      'Bristol Creative Cleaning',
      'Avon Plumbing Services',
      'South West Electrical'
    ],
    services: [
      'Creative Web Solutions',
      'Tech Startup Websites',
      'Sustainable Business Focus',
      'Performance Optimization',
      'User Experience Design',
      'Growth Marketing'
    ],
    keyPoints: [
      'Creative and tech-focused business community',
      'Sustainability important to local market',
      'High design standards expected',
      'Innovation and creativity valued'
    ]
  },
  {
    id: 8,
    slug: 'edinburgh',
    name: 'Edinburgh',
    region: 'Scotland',
    population: '540,000',
    description: 'Scotland\'s capital city demands websites that reflect its prestigious status. We create sophisticated web designs that help Edinburgh businesses maintain their competitive edge.',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop',
    clients: [
      'Edinburgh Heritage Builders',
      'Royal Mile Cleaning',
      'Castle Rock Plumbing',
      'Lothian Electrical Services'
    ],
    services: [
      'Premium Website Design',
      'Financial Services Websites',
      'Heritage Business Solutions',
      'Professional Branding',
      'High-End Development',
      'Executive Consulting'
    ],
    keyPoints: [
      'High-end market expecting premium solutions',
      'Strong financial and legal sectors',
      'Heritage and tradition important',
      'International business focus'
    ]
  },
  {
    id: 9,
    slug: 'cardiff',
    name: 'Cardiff',
    region: 'Wales',
    population: '370,000',
    description: 'Wales\' capital city is growing rapidly, and we help Cardiff businesses keep pace with modern, effective web design that captures the Welsh spirit of innovation.',
    image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop',
    clients: [
      'Welsh Dragon Builders',
      'Cardiff Bay Cleaning',
      'Valleys Plumbing Services',
      'Cymru Electrical Solutions'
    ],
    services: [
      'Welsh Business Websites',
      'Bilingual Web Design',
      'Government Sector Solutions',
      'Local SEO Wales',
      'Community Focused Design',
      'Cultural Sensitivity'
    ],
    keyPoints: [
      'Bilingual requirements (Welsh/English)',
      'Strong government and public sector',
      'Community-focused business culture',
      'Growing international profile'
    ]
  },
  {
    id: 10,
    slug: 'nottingham',
    name: 'Nottingham',
    region: 'East Midlands',
    population: '330,000',
    description: 'Nottingham\'s rich history and modern innovation create unique opportunities. We help local businesses blend tradition with cutting-edge web design.',
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&h=400&fit=crop',
    clients: [
      'Sherwood Construction',
      'Nottingham Forest Cleaning',
      'Robin Hood Plumbing',
      'Midlands Electrical Co'
    ],
    services: [
      'Heritage Business Websites',
      'Modern Web Development',
      'Local History Integration',
      'Tourism Sector Solutions',
      'Manufacturing Websites',
      'Educational Institution Sites'
    ],
    keyPoints: [
      'Rich heritage requiring respectful modern approach',
      'Strong manufacturing base',
      'Growing student population',
      'Tourism potential through historical connections'
    ]
  },
  {
    id: 11,
    slug: 'aylesbury',
    name: 'Aylesbury',
    region: 'Buckinghamshire',
    population: '75,000',
    description: 'Our home base! As a local Aylesbury company, we understand exactly what businesses in Buckinghamshire need to succeed online. We\'ve helped dozens of local tradespeople and businesses transform their digital presence.',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=600&h=400&fit=crop',
    clients: [
      'Mitchell Plumbing Services',
      'Thompson Building Services',
      'Clean & Bright Services',
      'Aylesbury Electricians Ltd',
      'Premier Roofing Solutions',
      'Garden Masters Landscaping'
    ],
    services: [
      'Local Trade Websites',
      'Aylesbury SEO Services',
      'Community Business Focus',
      'Personal Service Approach',
      'Ongoing Local Support',
      'Buckinghamshire Marketing'
    ],
    keyPoints: [
      'Our local expertise and presence',
      'Deep understanding of Aylesbury market',
      'Personal relationships with local businesses',
      'Proven track record in the area'
    ]
  },
  {
    id: 12,
    slug: 'oxford',
    name: 'Oxford',
    region: 'Oxfordshire',
    population: '155,000',
    description: 'The City of Dreaming Spires demands websites that match its academic excellence and business innovation. We create sophisticated web solutions for Oxford\'s diverse business community.',
    image: 'https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=600&h=400&fit=crop',
    clients: [
      'Oxford Academic Services',
      'Dreaming Spires Cleaning',
      'Thames Valley Builders',
      'University City Electrical'
    ],
    services: [
      'Academic Institution Websites',
      'Research Organization Sites',
      'Professional Service Design',
      'Educational Technology',
      'Innovation Hub Solutions',
      'Knowledge Transfer Sites'
    ],
    keyPoints: [
      'Academic and research community focus',
      'High intellectual standards expected',
      'International reputation considerations',
      'Innovation and knowledge transfer important'
    ]
  }
];

export const getServiceAreaBySlug = (slug) => {
  return serviceAreasData.find(area => area.slug === slug);
};

export const getServiceAreasByRegion = () => {
  const regions = {};
  serviceAreasData.forEach(area => {
    if (!regions[area.region]) {
      regions[area.region] = [];
    }
    regions[area.region].push(area);
  });
  return regions;
};